import * as React from 'react';
import { Link } from 'react-router';
import _ from 'lodash';

import 'views/trident-campaigns/common/TridentCampaignView.scss';
import './TridentTemplateCard.scss';
import './ProgressPanelItem.scss';
import { TRIDENT_CAMPAIGN_PROGRESS_DETAIL_FIELDS } from 'constants/ucd';
import { Icon } from 'semantic-grab-ui/src';
import openLinkIcon from 'img/open_link.svg';


type Props = {
  title: string,
  index: number, // change to this page index when this item is clicked
  activeIndex: number, // current active index
  details?: Array<any>, // [{fieldName:'..', fieldValue:'...', url'...'}]
  placeholder: string, // text to show when the details is empty
  onSectionSelected?: Function, // callback function
  targetUserType: string,
  clickable: Boolean,
};


export class ProgressPanelItem extends React.Component {
  props: Props;

  render() {
    const {
      index,
      title,
      activeIndex,
      placeholder,
      details,
      onSectionSelected,
      clickable,
    } = this.props;
    const isActiveIndex = activeIndex === index;

    let panelClassName = 'card-container progress-item-card-detail';
    let circleClassName = 'number-circle';

    if (isActiveIndex) {
      panelClassName += ' card-active';
    } else {
      circleClassName += !_.isEmpty(details) ? ' filled' : ' greyed';
    }

    // schedule
    const getLinker = (text: string, url: string) => {
      return (
        <Link className="linker" to={url} target="_blank">
          <span>{text} </span><img style={{ float: 'none' }} src={openLinkIcon} height={'9px'} alt={''} />
        </Link>
      );
    };

    const getDisplayValue = (detail) => {
      const value = _.get(detail, TRIDENT_CAMPAIGN_PROGRESS_DETAIL_FIELDS.fieldValue);
      const url = _.get(detail, TRIDENT_CAMPAIGN_PROGRESS_DETAIL_FIELDS.fieldUrl);
      const isUrlDefined = !_.isEmpty(url);

      if (isUrlDefined) {
        return (
          getLinker(value, url)
        );
      }
      return value;
    };

    return (
      <div className={`progress-item-container ${clickable ? '' : 'disabled'}`} onClick={() => { if (clickable) onSectionSelected(index); }}>
        {/* Circle Number */}
        <div className={'progress-item-card-number'}>
          <div className={circleClassName}>
            {!_.isEmpty(details) ? <Icon name="check" /> : index}
          </div>
        </div>

        {/* Square Panel */}
        <div className={'horizontal-line'}>
          <div className={panelClassName}>

            <h3>{title}</h3>
            {!_.isEmpty(details)
              ? (
                _.map(details, detail =>
                  (<div className={'progress-item-card-detail-expand'} key={_.get(detail, TRIDENT_CAMPAIGN_PROGRESS_DETAIL_FIELDS.fieldValue, '')}>
                    <h4>{_.get(detail, TRIDENT_CAMPAIGN_PROGRESS_DETAIL_FIELDS.fieldName, '')}</h4>
                    <p>{getDisplayValue(detail)}</p>
                  </div>)
                )
              ) :
              <div className={'progress-item-card-detail-shrink'}>
                <p>{placeholder}</p>
              </div>
            }
          </div>
        </div>
      </div>
    )
    ;
  }
}

export default ProgressPanelItem;
